module.exports = "data:image/jpeg;base64,iVBORw0KGgoAAAANSUhEUgAAABMAAAALCAYAAACd1bY6AAAABHNCSVQICAgIfAhkiAAAANtJREFUKFOd0q8PgUEYwHHHRlAUTdRMVOn+A5rNRhII6rupNInZNP+ArqtETZMExWbO9zFnh/cc723P7t7nx2f3vntVzLO01mVaKkqpga9XfWsAKlCfECnZAeXsXE4MKMfUnMhY0wHg0qWFYkBZBqaEgPa68NABXIeBHxhQmsYZkXfc4ES+Cbh7r79gQAkaxkTJ87EP1FuAe7vviQHFKQRE1QOZskANwKNJ2FiPZO1HyLRtOLQBz5K4Y9yqztb9EzLtKw59wKt6/JRDEvKaUdcCbCRYESEZVbHmtjeh7TsQ37JzwQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/top.jpg
// module id = SXi6
// module chunks = 3